/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForSecurityRecommendation extends models.GovernanceConfigurationBaseForSecurity {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForSecurityRecommendation.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForSecurityRecommendation>): GovernanceConfigurationBaseForSecurityRecommendation {
        let obj = Object.assign(new GovernanceConfigurationBaseForSecurityRecommendation(), model);
        GovernanceConfigurationBaseForSecurityRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForSecurityRecommendation>): GovernanceConfigurationBaseForSecurityRecommendation {
        if (!model) return null;
        return GovernanceConfigurationBaseForSecurityRecommendation.newInstance(<GovernanceConfigurationBaseForSecurityRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForSecurityRecommendation) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForSecurityRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForSecurityRecommendation): boolean {
        if (models.GovernanceConfigurationBaseForSecurity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForSecurityRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
